import { getArtistPersonId } from '../getArtistPersonId/getArtistPersonId';
import { Config } from '#lib/constants/config.js';
import { GlobalRoutes } from '#lib/features/navigation/constants/global-routes.js';
import type { ArtistRef } from '#lib/features/seo/types.js';
import { omitEmpty } from '$global/utils/omitEmpty/omitEmpty';

export const getArtistPerson = (artist: ArtistRef) => {
	if (!artist?.name) {
		return undefined;
	}

	// Hidden artist pages 404, so they get no id/url to point at.
	const slug = artist.slug && !artist.hide_artist_page ? artist.slug : null;

	return omitEmpty({
		'@type': 'Person',
		'@id': slug ? getArtistPersonId(slug) : undefined,
		name: artist.name,
		url: slug
			? `${Config.Domain}${GlobalRoutes.ArtistsHome}/${slug}`
			: undefined,
	});
};
